module.exports = __webpack_public_path__ + "img/mejores-practicas.e4050123.png";